interface ErrorMessage {
  code: string;
  error: string;
  message: string;
}

export class HttpHandler {
  statusCode: number;
  code: string | undefined;
  error: string | undefined;
  message: string | undefined;
  payload: any | undefined;

  constructor(statusCode: number, errorMessage?: ErrorMessage) {
    const { code, error, message, ...rest } = errorMessage || {};
    this.statusCode = statusCode;
    this.code = code;
    this.error = error;
    this.message = message;
    this.payload = rest;
  }

  async handle(res: Response) {
    let data;

    try {
      try {
        data = await res.json();
      } catch (err) {
        data = await res.text();
      }
    } catch (err) {
      //
    }

    // Any 2xx is success (200 OK, 201 Created, 204 No Content, ...); 304 Not
    // Modified returns the cached body. Everything else is an error. Previously
    // only 200/304 were accepted, so a 201 (e.g. comment POST) wrongly threw.
    if ((this.statusCode >= 200 && this.statusCode < 300) || this.statusCode === 304) {
      return data;
    }
    throw new HttpHandler(this.statusCode, data);
  }
}

export default HttpHandler;
